import { COMPACT_SEARCH_INPUT_OPTIONS } from '~services/constant/compact';
import HelperOptions from '~component/helper/helper-options';

// 搜索合同的输入框，对应的字段类型
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;

    return (
      <HelperOptions
        { ...data }
        options={ COMPACT_SEARCH_INPUT_OPTIONS }
      />
    );
  },
};
